import { LiveAutomationSection } from "./LiveAutomationSection";
import { OkxCredentialSection } from "./OkxCredentialSection";
import { StrategyFormSection } from "./StrategyFormSection";

export function StrategyControls({
  bot,
  botBusy,
  onToggleBot,
  risk,
  setRisk,
  onSaveRisk,
  okxCredentials,
  liveAutomation,
  liveConfig,
  setLiveConfig,
  onToggleLiveAutomation,
}) {
  return (
    <aside className="panel control-panel" data-testid="strategy-control-panel">
      <StrategyFormSection {...{ bot, botBusy, onToggleBot, risk, setRisk, onSaveRisk }} />
      <OkxCredentialSection okxCredentials={okxCredentials} />
      <LiveAutomationSection {...{ liveAutomation, liveConfig, setLiveConfig, onToggleLiveAutomation }} />
    </aside>
  );
}